import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=5e1b58fc&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=babel&"
export * from "./Resource.vue?vue&type=script&lang=babel&"
import style0 from "./Resource.vue?vue&type=style&index=0&id=5e1b58fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1b58fc",
  null
  
)

export default component.exports